import { format, isValid, startOfYear, sub } from 'date-fns';
import { DATE_RANGE_OPTIONS, type DateInput } from '../types';

export const getStartDate = ({
  dateRange,
  customStartDateValue,
}: {
  dateRange: DATE_RANGE_OPTIONS;
  customStartDateValue: DateInput;
}): Date | null => {
  switch (dateRange) {
    case DATE_RANGE_OPTIONS.CUSTOM:
      return customStartDateValue ? new Date(customStartDateValue) : null;
    case DATE_RANGE_OPTIONS.LTD:
      return sub(new Date(), { days: 30 });
    case DATE_RANGE_OPTIONS.LTM:
      return sub(new Date(), { years: 1 });
    case DATE_RANGE_OPTIONS.YTD:
      return startOfYear(new Date());
    default:
      return null;
  }
};

export const getEndDate = ({
  dateRange,
  customEndDateValue,
}: {
  dateRange: DATE_RANGE_OPTIONS;
  customEndDateValue: DateInput;
}): Date | null => {
  switch (dateRange) {
    case DATE_RANGE_OPTIONS.CUSTOM:
      return customEndDateValue ? new Date(customEndDateValue) : null;
    case DATE_RANGE_OPTIONS.LTD:
    case DATE_RANGE_OPTIONS.LTM:
    case DATE_RANGE_OPTIONS.YTD:
      return new Date();
    default:
      return null;
  }
};

export const isValidDate = (date: DateInput): date is Date | string => {
  if (!date) {
    return false;
  }
  return isValid(date) || isValid(new Date(date));
};

export const getDateFilterChipLabel = ({
  dateRange,
  endDate,
  startDate,
}: {
  dateRange: DATE_RANGE_OPTIONS;
  endDate: DateInput;
  startDate: DateInput;
}) => {
  switch (dateRange) {
    case DATE_RANGE_OPTIONS.CUSTOM:
      return isValidDate(startDate) && isValidDate(endDate)
        ? `${format(startDate, 'M/d/yy')} - ${format(endDate, 'M/d/yy')}`
        : '';
    case DATE_RANGE_OPTIONS.DEFAULT:
      return '';
    default:
      return dateRange;
  }
};

export const getDateFilterCount = ({
  dateRange,
  endDate,
  startDate,
}: {
  dateRange: DATE_RANGE_OPTIONS;
  endDate: DateInput;
  startDate: DateInput;
}) => {
  switch (dateRange) {
    case DATE_RANGE_OPTIONS.CUSTOM:
      return isValid(endDate) && isValid(startDate) ? 1 : 0;
    case DATE_RANGE_OPTIONS.LTD:
    case DATE_RANGE_OPTIONS.LTM:
    case DATE_RANGE_OPTIONS.YTD:
      return 1;
    default:
      return 0;
  }
};
